import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { LazyLoadImage } from "react-lazy-load-image-component";

import ConditionalRender from "../../components/Common/ConditionalRender";
import Button from "../../components/Common/Button";
import { useHandleClickLoading } from "../../components/Common/utils";

function ArticleSlider({ articleData, articleLoading }) {
    const isWebSetting = localStorage.getItem('isWebSetting');
    const parseWebSetting = JSON.parse(isWebSetting);
    const handleClickLoading = useHandleClickLoading();

    return (
        <div className="flex flex-col py-3 rounded-none  bg-cardLight dark:bg-cardDark">
            <div className="flex flex-col gap-1 px-3">
                <div className="flex flex-row gap-3 items-end z-10">
                    <span className="text-base font-bold">
                        Artikel
                    </span>
                </div>
                <div className="relative h-28 w-full">
                    <ConditionalRender
                        productsData={articleData}
                        isLoading={articleLoading}
                        model={"emptyData"}
                    >
                        <div className=" absolute top-0 left-0 right-0 bottom-0">
                            <Swiper
                                className="w-full h-full py-2"
                                spaceBetween={10}
                                loop={true}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 1,
                                    },
                                    640: {
                                        slidesPerView: 2,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                    },
                                    1280: {
                                        slidesPerView: 4,
                                    },
                                    1536: {
                                        slidesPerView: 5,
                                    },
                                }}
                                modules={[Autoplay]}
                            >
                                {articleData.map((item, index) => {
                                    return (
                                        <SwiperSlide
                                            key={index}
                                            className="flex flex-col group hover:border-[#22BDE2] sw-auto aspect-square"
                                        >
                                            <button onClick={() => handleClickLoading('/news/' + item.slug)} className="flex flex-1 flex-row h-full gap-2 w-full">
                                                <div className="flex flex-col relative rounded-lg overflow-hidden aspect-square h-full basis-4/12 ">
                                                    <LazyLoadImage
                                                        src={item.gambar}
                                                        alt={item.nama}
                                                        height={"100%"}
                                                        className="rounded-lg w-full h-full object-cover group-hover:blur-xl"
                                                        effect="blur"
                                                    />
                                                    <div className="absolute w-full h-full hidden items-center justify-center group-hover:flex">
                                                        <img
                                                            src={parseWebSetting?.favicon}
                                                            alt="Logo"
                                                            width={'30%'}
                                                            height={'30%'}
                                                            className="white-filter"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="flex flex-col flex-1 h-full justify-between">
                                                    <span className="text-sm line-clamp-3 text-left">
                                                        {item.judul}
                                                    </span>
                                                    <span className="text-xs line-clamp-4 text-left opacity-75">
                                                        {item.tanggal}
                                                    </span>
                                                </div>
                                            </button>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div>
                    </ConditionalRender>
                </div>
            </div>
            <div className="flex flex-row justify-center pt-2">
                <div>
                    <Button
                        initialValue="Tampilkan Semua"
                        type="fill"
                        className="border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor inline-flex rounded-md"
                        onClick={() => { handleClickLoading('/blog') }}
                    />
                </div>
            </div>
        </div>
    );
}

export default ArticleSlider;
